import React from 'react'
import GLoading from 'tennders-market/common/components/element/GLoading'
import DOMPurify from 'dompurify'

type Props = {
  loading: boolean,
  suggestions: Record<string, any>[],
  setSuggestionSelected: (suggestion: Record<string, any>) => void,
    selectedIndex ?: number
}

const LocationSuggestions = React.forwardRef<any, Props>((props, ref) => {
  const {
    loading,
    suggestions,
    setSuggestionSelected,
    selectedIndex
  } = props

  if (loading) {
    return (
      <div
        style={{
          position: 'absolute',
          backgroundColor: 'transparent',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          margin: 'auto',
          display: 'flex',
          borderRadius: '6px'
        }}
      >
        <GLoading color="#000" size={14} />
      </div>
    )
  }

  if (suggestions.length === 0) {
    return null
  }

  return (
    <ul
      ref={ref as never}
      style={{
        position: 'absolute',
        top: '40px',
        left: '0',
        padding: 12,
        border: '1px solid #ddd',
        boxShadow: '0 0 10px rgb(0 0 0 / 15%)',
        backgroundColor: 'white',
        zIndex: 99999
      }}
    >
      {suggestions?.map((item, i) => (
        <li
          style={{
            padding: 3,
            cursor: 'pointer',
            minHeight: 35,
            borderLeft: i === selectedIndex ? '2px solid #0879cf' : 'none'
          }}
          key={item.label}
          onClick={() => setSuggestionSelected(item)}
        >
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item?.label || item.description) }} />
        </li>
      ))}
    </ul>
  )
})

export default LocationSuggestions
